import { Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { centeredImage } from '@features/executive-report/slides/centered-image';
import { DEFAULT_SLIDE_MASTER } from '../slide-master';

export const buildCampaignOverviewSlide2 = (
  brandLogoWithMetadata: ImageWithMetadata | null,
  texts: Slide['texts'],
  shapes: Slide['shapes']
): Slide => {
  const images: Slide['images'] = brandLogoWithMetadata
    ? [
        centeredImage({
          image: brandLogoWithMetadata,
          maxWidth: 3.2,
          maxHeight: 1.07,
          x: 0.74,
          y: 2.45,
        }),
      ]
    : [];

  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts,
    images,
    shapes,
  };
};
